import React from "react";

const SortBar = () => {
  return <div>SortBar</div>;
};

export default SortBar;
